/**
 * TypeBox schemas for Track entity
 */

import { Type, type Static } from 'typebox'
import { UUID, ISODate, Bounds, type Exact } from './common.js'

/** GeoJSON type preserved for TypeScript consumers; runtime validation handled imperatively */
const GeoJSONData = Type.Unsafe<GeoJSON.FeatureCollection | GeoJSON.Feature | GeoJSON.Geometry>(
  Type.Unknown()
)

export const ElevationSchema = Type.Object({
  gain: Type.Number(),
  loss: Type.Number(),
  max: Type.Number(),
  min: Type.Number(),
})

export const TrackSchema = Type.Object({
  id: UUID,
  tripId: UUID,
  name: Type.String({ minLength: 1, maxLength: 100 }),
  description: Type.Optional(Type.String()),
  type: Type.Union([Type.Literal('planned'), Type.Literal('recorded'), Type.Literal('imported')]),
  geojson: GeoJSONData,
  bounds: Bounds,
  pointCount: Type.Number({ exclusiveMinimum: 0 }),
  distance: Type.Number({ minimum: 0 }),
  elevation: Type.Optional(ElevationSchema),
  gpxData: Type.Optional(Type.String()),
  startTime: Type.Optional(ISODate),
  endTime: Type.Optional(ISODate),
  duration: Type.Optional(Type.Number()),
  createdAt: ISODate,
  updatedAt: ISODate,
})
export type Track = Exact<Static<typeof TrackSchema>>

/** Fields required when creating a track */
export const TrackCreateSchema = Type.Object({
  tripId: UUID,
  name: Type.String({ minLength: 1, maxLength: 100 }),
  type: Type.Union([Type.Literal('planned'), Type.Literal('recorded'), Type.Literal('imported')]),
  geojson: GeoJSONData,
})

/** Partial track for updates */
export const TrackUpdateSchema = Type.Partial(TrackSchema)
